import React from "react";
import BlogCard from "../../cards/blogCard";
import { useTranslation } from "react-i18next";

const Blogcards = () => {
  const { t } = useTranslation();

  const blogs = [
    {
      image: "../../assets/images/home/blogimg2.png",
      date: "19 Feb 2024",
      author: "andrew",
      title: t("blog.cards.one.title"),
      categories: t("blog.cards.one.categories"),
    },
    {
      image: "../../assets/images/home/blogimg2.png",
      date: "19 Feb 2024",
      author: "andrew",
      title: t("blog.cards.two.title"),
      categories: t("blog.cards.two.categories"),
    },
    {
      image: "../../assets/images/home/blogimg2.png",
      date: "19 Feb 2024",
      author: "andrew",
      title: t("blog.cards.three.title"),
      categories: t("blog.cards.three.categories"),
    },
    {
      image: "../../assets/images/home/blogimg2.png",
      date: "19 Feb 2024",
      author: "andrew",
      title: t("blog.cards.four.title"),
      categories: t("blog.cards.four.categories"),
    },
    {
      image: "../../assets/images/home/blogimg2.png",
      date: "19 Feb 2024",
      author: "andrew",
      title: t("blog.cards.five.title"),
      categories: t("blog.cards.five.categories"),
    },
    {
      image: "../../assets/images/home/blogimg2.png",
      date: "19 Feb 2024",
      author: "andrew",
      title: t("blog.cards.six.title"),
      categories: t("blog.cards.six.categories"),
    },
  ];

  return (
    <>
      <div className="max-w-[80%] mt-[60px] max-xxxl:max-w-[90%] m-auto  flex flex-col items-center gap-[81px]">
        <h2 className="heading-color tracking-[-3px] leading-[60px] font-sora">
          {t("blog.hero.title")}
          <span className="light-blue-color">{t("blog.hero.span")}</span>
        </h2>
        <div className="flex items-center max-sm:flex-col max-md:gap-[20px] gap-[152px] justify-center">
          <div className="w-[50%] max-sm:w-[100%]">
            <img
              src="../../assets/images/blogs/blogs-ai.png"
              alt=""
              className="w-100 h-100"
            />
          </div>
          <div className="left-section flex flex-col gap-[22px] w-[50%] max-sm:w-[100%]">
            <h2 className="heading-color tracking-[-3px] leading-[60px] font-sora">
              {t("blog.hero.subtitle")}
            </h2>
            <p className="large max-w-[504px] max-sm:max-w-[100%] leading-[35px] txt-color font-medium">
              {t("blog.hero.desc")}
            </p>
          </div>
        </div>
      </div>
      <div className="w-full bg-white py-[81px]">
        <div className="w-[80%] m-auto max-xxxl:w-[90%]">
          <div className="grid grid-cols-1 gap-[20px] md:grid-cols-2 lg:grid-cols-3 gap-x-[30px] gap-y-[20px]">
            {blogs.map((blog, index) => (
              <BlogCard key={index} blog={blog} />
            ))}
          </div>
        </div>
      </div>{" "}
    </>
  );
};

export default Blogcards;
